import React from 'react';

const TwitterNewsItem = ({item}) => (
  <div className="twitter--column col-4">
    <a
      className="twitter-timeline"
      href="https://twitter.com/NHSOrkney"
      data-show-replies="false"
      data-chrome="noheader nofooter noborders"
      data-tweet-limit="2">NHS Orkney Tweets</a>
  </div>
);

export default TwitterNewsItem;
